import { apiWithoutBaseURL } from './api'

class GraphService {
    // 批量添加节点和关系
    async addByBatch(data) {
        try {
            const response = await apiWithoutBaseURL.post('/Graph/api/addByBatch/', data)
            return response.data
        } catch (error) {
            console.error('批量添加失败:', error)
            throw error
        }
    }

    // 修改图谱关系
    async changeGraph(data) {
        try {
            const response = await apiWithoutBaseURL.post('/Graph/api/changeGraph/', data)
            return response.data
        } catch (error) {
            console.error('修改图谱关系失败:', error)
            throw error
        }
    }

    // 翻译单词
    async translateWord(word) {
        try {
            const response = await apiWithoutBaseURL.post('/Graph/api/translateWord/', { word })
            return response.data
        } catch (error) {
            console.error('翻译单词失败:', error)
            throw error
        }
    }

    // 为节点添加标签
    async addTagToNode(nodeId, tagName) {
        try {
            const response = await apiWithoutBaseURL.post('/Graph/api/addTagToNode/', {
                node_id: nodeId,
                tag_name: tagName
            })
            return response.data
        } catch (error) {
            console.error('为节点添加标签失败:', error)
            throw error
        }
    }

    // 为节点移除标签
    async removeTagToNode(nodeId, tagId) {
        try {
            const response = await apiWithoutBaseURL.post('/Graph/api/removeTagToNode/', {
                node_id: nodeId,
                tag_id: tagId
            })
            return response.data
        } catch (error) {
            console.error('为节点移除标签失败:', error)
            throw error
        }
    }

    // 检查节点是否存在
    async checkNode(nodeName) {
        try {
            const response = await apiWithoutBaseURL.get('/Graph/api/checkNode/', {
                params: { node_name: nodeName }
            })
            return response.data
        } catch (error) {
            console.error('检查节点失败:', error)
            throw error
        }
    }

    // 查找所有标签
    async findTags() {
        try {
            const response = await apiWithoutBaseURL.get('/Graph/api/findTags/')
            return response.data
        } catch (error) {
            console.error('查找标签失败:', error)
            throw error
        }
    }

    // 查找所有标签
    async findAllTags() {
        try {
            const response = await apiWithoutBaseURL.get('/Graph/api/findAllTags/')
            return response.data
        } catch (error) {
            console.error('查找所有标签失败:', error)
            throw error
        }
    }

    // 根据节点查找图谱关系
    async findGraphByNode(nodeName, times = 0) {
        try {
            let url = `/Graph/api/findGraphByNode/${nodeName}/`
            if (times > 0) {
                url = `/Graph/api/findGraphByNode/${nodeName}/${times}/`
            }
            const response = await apiWithoutBaseURL.get(url)
            return response.data
        } catch (error) {
            console.error('根据节点查找图谱关系失败:', error)
            throw error
        }
    }

    // 查找节点
    async findNode(nodeName) {
        try {
            const response = await apiWithoutBaseURL.get(`/Graph/api/findNode/${nodeName}/`)
            return response.data
        } catch (error) {
            console.error('查找节点失败:', error)
            throw error
        }
    }

    // 修改节点
    async modifyNode(nodeId, nodeName, nodeDesc) {
        try {
            // 使用POST请求传递参数，避免URL中特殊字符导致的问题
            const response = await apiWithoutBaseURL.post('/Graph/api/modifyNode/', {
                nodeId: nodeId,
                nodeName: nodeName,
                nodeDesc: nodeDesc
            })
            return response.data
        } catch (error) {
            console.error('修改节点失败:', error)
            throw error
        }
    }

    // 删除节点
    async deleteNode(nodeId) {
        try {
            const response = await apiWithoutBaseURL.get(`/Graph/api/deleteNode/${nodeId}/`)
            return response.data
        } catch (error) {
            console.error('删除节点失败:', error)
            throw error
        }
    }

    // 添加节点
    async addNode(nodeName, nodeDesc = null) {
        try {
            // 使用POST请求传递参数，避免URL中特殊字符导致的问题
            const response = await apiWithoutBaseURL.post('/Graph/api/addNode/', {
                nodeName: nodeName,
                nodeDesc: nodeDesc
            })
            return response.data
        } catch (error) {
            console.error('添加节点失败:', error)
            throw error
        }
    }

    // 添加子节点
    async addChildNode(nodeId, nodeName, graphId, nodeDesc = null) {
        try {
            // 使用POST请求传递参数，避免URL中特殊字符导致的问题
            const response = await apiWithoutBaseURL.post('/Graph/api/addChildNode/', {
                nodeId: nodeId,
                nodeName: nodeName,
                graphId: graphId,
                nodeDesc: nodeDesc
            })
            return response.data
        } catch (error) {
            console.error('添加子节点失败:', error)
            throw error
        }
    }

    // 添加关系
    async addGraph(sourceId, targetId, graphId, description = '') {
        console.log('addGraph:', sourceId, targetId, graphId, description)
        try {
            const response = await apiWithoutBaseURL.post('/Graph/api/addGraph/', {
                source: sourceId,
                target: targetId,
                graphId: graphId,
                description: description
            })
            return response.data
        } catch (error) {
            console.error('添加关系失败:', error)
            throw error
        }
    }

    // 删除关系
    async deleteGraph(sourceId, targetId, graphId) {
        try {
            const response = await apiWithoutBaseURL.post('/Graph/api/deleteGraph/', {
                source: sourceId,
                target: targetId,
                graphId: graphId
            })
            return response.data
        } catch (error) {
            console.error('删除关系失败:', error)
            throw error
        }
    }

    // 修改关系
    async modifyGraph(fromNodeId, toNodeId, graphId, description, strength) {
        try {
            const response = await apiWithoutBaseURL.post('/Graph/api/modifyGraph/', {
                fromNodeId: fromNodeId,
                toNodeId: toNodeId,
                graphId: graphId,
                description: description,
                strength: strength
            })
            return response.data
        } catch (error) {
            console.error('修改关系失败:', error)
            throw error
        }
    }

    // 查找所有关系
    async findAllGraphs() {
        try {
            const response = await apiWithoutBaseURL.get('/Graph/api/findAllGraphs/')
            return response.data
        } catch (error) {
            console.error('查找所有关系失败:', error)
            throw error
        }
    }

    // 添加标签
    async addTag(tagName) {
        try {
            const response = await apiWithoutBaseURL.post('/Graph/api/addTag/', {
                tagName: tagName
            })
            return response.data
        } catch (error) {
            console.error('添加标签失败:', error)
            throw error
        }
    }

    // 模糊查找节点
    async fuzzyFindNode(nodeName) {
        try {
            const response = await apiWithoutBaseURL.get(`/Graph/api/fuzzyFindNode/${nodeName}/`)
            return response.data
        } catch (error) {
            console.error('模糊查找节点失败:', error)
            throw error
        }
    }

    // 查找futureEngine相关的节点和关系
    async findFutureEngineData(page = 1, pageSize = 100) {
        try {
            const response = await apiWithoutBaseURL.get('/Graph/api/findFutureEngineData/', {
                params: {
                    page: page,
                    page_size: pageSize
                }
            })
            return response.data
        } catch (error) {
            console.error('查找FutureEngine数据失败:', error)
            throw error
        }
    }

    // 查找指定用户的futureEngine相关的节点和关系
    async findFutureEngineDataForUser(page = 1, pageSize = 100, userId) {
        try {
            const response = await apiWithoutBaseURL.get('/Graph/api/findFutureEngineDataForUser/', {
                params: {
                    page: page,
                    page_size: pageSize,
                    userId: userId
                }
            })
            return response.data
        } catch (error) {
            console.error('查找指定用户的FutureEngine数据失败:', error)
            throw error
        }
    }

    // 查找futureEngine graph的ID
    async findFutureEngineGraphId() {
        try {
            // 这里可以通过查找名为"futureEngine"的节点来获取其对应的graph ID
            // 或者通过其他方式获取
            const response = await apiWithoutBaseURL.get('/Graph/api/findFutureEngineGraphId/')
            console.log("findFutureEngineGraphId2:", response.data)
            console.log(response.data.data.graphId);
            // 从返回的数据中提取graphId
            if (response.data && response.data.data.graphId) {
                return response.data.data.graphId;
            }
            return null;
        } catch (error) {
            console.error('查找FutureEngine Graph ID失败:', error)
            throw error
        }
    }

    // 查找futureStudy相关的节点和关系
    async findFutureStudyData(nodeId = null) {
        try {
            if (nodeId) {
                const response = await apiWithoutBaseURL.get('/Graph/api/findFutureStudyData/', {
                    params: { nodeId: nodeId }
                });
                return response.data;
            } else {
                const response = await apiWithoutBaseURL.get('/Graph/api/findFutureStudyData/')
                return response.data
            }
        } catch (error) {
            console.error('查找FutureStudy数据失败:', error)
            throw error
        }
    }
    // 查找futurePractice相关的节点和关系
    async findFuturePracticeData(nodeId = null) {
        try {
            if (nodeId) {
                const response = await apiWithoutBaseURL.get('/Graph/api/findFuturePracticeData/', {
                    params: { nodeId: nodeId }
                });
                return response.data;
            } else {
                const response = await apiWithoutBaseURL.get('/Graph/api/findFuturePracticeData/')
                return response.data
            }
        } catch (error) {
            console.error('查找FuturePractice数据失败:', error)
            throw error
        }
    }
    // 查找futureStudy graph的ID
    async findFutureStudyGraphId() {
        try {
            const response = await apiWithoutBaseURL.get('/Graph/api/findFutureStudyGraphId/')
            console.log("findFutureStudyGraphId:", response.data)
            console.log(response.data.data.graphId);
            // 从返回的数据中提取graphId
            if (response.data && response.data.data.graphId) {
                return response.data.data.graphId;
            }
            return null;
        } catch (error) {
            console.error('查找FutureStudy Graph ID失败:', error)
            throw error
        }
    }

    // 查找futurePractice graph的ID
    async findFuturePracticeGraphId() {
        try {
            const response = await apiWithoutBaseURL.get('/Graph/api/findFuturePracticeGraphId/')
            console.log("findFuturePracticeGraphId:", response.data)
            console.log(response.data.data.graphId);
            // 从返回的数据中提取graphId
            if (response.data && response.data.data.graphId) {
                return response.data.data.graphId;
            }
            return null;
        } catch (error) {
            console.error('查找FuturePractice Graph ID失败:', error)
            throw error
        }
    }
    // 获取所有用户
    async getAllUsers() {
        try {
            const response = await apiWithoutBaseURL.get('/api/usermodel/')
            return response.data
        } catch (error) {
            console.error('获取所有用户失败:', error)
            throw error
        }
    }

    // 添加统计数据
    async addStatistics(fromNodeId, userId, result, desc) {
        try {
            const response = await apiWithoutBaseURL.post('/Graph/api/addStatistics/', {
                fromNodeId: fromNodeId,
                userId: userId,
                result: result,
                desc: desc
            });
            return response.data;
        } catch (error) {
            console.error('添加统计数据失败:', error);
            throw error;
        }
    }

    // 获取统计数据
    async getStatistics(fromNodeId, userId) {
        try {
            const response = await apiWithoutBaseURL.post('/Graph/api/getStatistics/', {
                fromNodeId: fromNodeId,
                userId: userId
            });
            return response.data;
        } catch (error) {
            console.error('获取统计数据失败:', error);
            throw error;
        }
    }

    // 添加布置作业
    async addHomeworks(fromNodeId, userId, questions) {
        try {
            const response = await apiWithoutBaseURL.post('/Graph/api/addHomeworks/', {
                fromNodeId: fromNodeId,
                userId: userId,
                questions: questions
            });
            return response.data;
        } catch (error) {
            console.error('添加布置作业失败:', error);
            throw error;
        }
    }

    // 获取布置作业
    async getHomeworks(fromNodeId, userId) {
        try {
            const response = await apiWithoutBaseURL.post('/Graph/api/getHomeworks/', {
                fromNodeId: fromNodeId,
                userId: userId
            });
            return response.data;
        } catch (error) {
            console.error('获取布置作业失败:', error);
            throw error;
        }
    }

    // 获取我的作业
    async getMyHomeworks(userId) {
        try {
            const response = await apiWithoutBaseURL.post('/Graph/api/getMyHomeworks/', {
                userId: userId
            });
            return response.data;
        } catch (error) {
            console.error('获取我的作业失败:', error);
            throw error;
        }
    }

    // 更新作业状态
    async updateHomeworkStatus(homeworkId, description) {
        try {
            const response = await apiWithoutBaseURL.post('/Graph/api/updateHomeworkStatus/', {
                homeworkId: homeworkId,
                description: description
            });
            return response.data;
        } catch (error) {
            console.error('更新作业状态失败:', error);
            throw error;
        }
    }
}

export default new GraphService()